import type { GameState } from '@/types'

export class GameStateManager {
  private state: GameState = {
    cracksLeft: 0,
    totalCracked: 0,
    refCode: null,
    referredBy: null,
    refEarned: 0,

    // NEW defaults for streaks
    lastPlayed: null,
    streakCur: 0,
    streakBest: 0,
    streakTodayCounted: false,

    // Rewarded ad tracking
    canWatchRewardedAd: true,
  }

  private listeners: Array<(state: GameState) => void> = []

  getState(): GameState {
    return { ...this.state }
  }

  setState(newState: Partial<GameState>): void {
    this.state = { ...this.state, ...newState }
    this.notifyListeners()
  }

  subscribe(listener: (state: GameState) => void): () => void {
    this.listeners.push(listener)
    return () => {
      const index = this.listeners.indexOf(listener)
      if (index > -1) this.listeners.splice(index, 1)
    }
  }

  private notifyListeners(): void {
    this.listeners.forEach((listener) => listener(this.getState()))
  }
}
